import React, { useState } from 'react';

import AutTable from '../../../blocks/aut-grid-table';
import Select from '../../../themed/select/select';
import Button from '../../../themed/button';

import classNames from './style.module.scss';

import { PCNLAnomalyItem, SelectOption } from '../../../../utils/models';

export interface AnomalyToMove {
	pcnlItemName: string;
	anomaly: PCNLAnomalyItem;
}

interface Props {
	onMoveAnomalies: (sectionToMove: string) => void;
	allSections: SelectOption[];
	anomalyItems: AnomalyToMove[];
	onRemoveAnomalyItem: (anomalyToMove: AnomalyToMove) => void;
}

const MoveAnomalies: React.FC<Props> = ({
	onMoveAnomalies,
	allSections,
	anomalyItems,
	onRemoveAnomalyItem,
}) => {
	const [sectionToMove, setSectionToMove] = useState('');

	return (
		<div className={classNames.moveAnomalies}>
			<div className="d-flex justify-content-start align-items-center bg-white p-2 pb-1 border rounded">
				<Select
					name="move-anomaly"
					options={allSections}
					value={sectionToMove}
					placeholder="Select Section to Move Anomalies"
					onChange={(e) => setSectionToMove(e.currentTarget.value)}
				/>

				<div className="ms-2">
					<Button
						disabled={!sectionToMove}
						label="Move Anomalies"
						onClick={() => onMoveAnomalies(sectionToMove)}
						style={{ marginTop: 0, marginBottom: '0.5rem' }}
					/>
				</div>
			</div>

			<AutTable
				data={anomalyItems}
				tableColumns={anomalyColumns}
				onDeleteItem={() => onRemoveAnomalyItem}
			/>
		</div>
	);
};

const anomalyColumns = [
	{
		path: 'anomaly.id',
		label: 'Sr No.',
		content: (item: AnomalyToMove) => <span>{item.anomaly.id}</span>,
	},
	{
		path: 'pcnlItemName',
		label: 'PCNL Item Name',
		content: (item: AnomalyToMove) => <span>{item.pcnlItemName}</span>,
	},
	{
		path: 'anomaly.location',
		label: 'Location',
	},
	{
		path: 'anomaly.rootCause',
		label: 'Root Cause',
	},
	{
		path: 'anomaly.interventionRequired',
		label: 'Intervention Required',
	},
	{
		path: 'anomaly.description',
		label: 'Anomaly Description',
		content: (item: AnomalyToMove) => {
			return (
				<span>
					{item.anomaly.description.map(({ value }) => value).join('. ')}
				</span>
			);
		},
	},
	{
		path: 'recommendation',
		label: 'Recommendation',
		content: (item: AnomalyToMove) => (
			<span>
				{item.anomaly.recommendation.map(({ value }) => value).join('. ')}
			</span>
		),
	},
];

export default MoveAnomalies;
